var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"loading":_vm.loading,"outlined":"","elevation":"0"}},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('apexchart',{attrs:{"type":_vm.type,"height":"450","options":_vm.localOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }